import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const Spinner = () => <Spin indicator={<LoadingOutlined spin style={{ color: '#2588c9' }} />} size="large" />;

export { Spinner };
